// Types
import { I18nBasePaths } from 'src/types/i18n-paths';

/**
 * @description Edit the project's translated URLs here.
 * @description This is the object in which we will input the translated URLs in a humanly readable
 * form. Keep in mind that this object will be further transformed with helper functions in way that
 * will make it easy to use inside middleware, language switcher and url generator. You will not
 * need extra rewrites/redirects, it will be all handled from here.
 *
 * @example The object has the following properties:
 * {
 *   'url to actually render': {
 *     ro: 'path in browser for ro',
 *     en: 'path in browser for en',
 *     hu: 'path in browser for hu',
 *   }
 * }
 *
 * // some real life example
 * {
 *   '/marketing/salary/some-page': {
 *     ro: '/marketing/nume-pagina',
 *     en: '/marketing/page-name',
 *     hu: '/marketing/oldalnev'
 *   }
 * }
 *
 * @remarks Please keep in mind that the [path in browser for ...] doesn't need a lang prefix in the URL.
 */
export const i18nBasePaths: I18nBasePaths = {
  '/campaigns/cv-worth/:id': {
    ro: '/valoare-cv/:id',
    en: '/cv-worth/:id',
  },
  '/campaigns/cv-worth': {
    ro: '/valoare-cv',
    en: '/cv-worth',
  },
  // suffix the parameter with an asterisk (*) to denote a zero or more parameter matches.
  '/job/list/location-:location{/*otherParams}': {
    ro: '/locuri-de-munca-in-:location{/*otherParams}',
    en: '/jobs-in-:location{/*otherParams}',
  },
  //
  '/job/list{/*params}': {
    ro: '/locuri-de-munca{/*params}',
    en: '/jobs{/*params}',
  },
  '/job/:jobSlug': {
    ro: '/loc-de-munca/:jobSlug',
    en: '/job/:jobSlug',
  },
  '/companies/:slug': {
    ro: '/firme/:slug',
    en: '/companies/:slug',
  },
  // Mission Control - kept simple, no localization
  // Note: /mc is NOT in i18n paths because it's the same across all locales
  // The middleware will handle it as a regular route with default locale rewrite
  '/mc/job/list/location-:location{/*otherParams}': {
    ro: '/mc/locuri-de-munca-in-:location{/*otherParams}',
    en: '/mc/jobs-in-:location{/*otherParams}',
  },
  '/mc/job/list': {
    ro: '/mc/locuri-de-munca',
    en: '/mc/jobs',
  },
  '/mc/job/list/:keyword': {
    ro: '/mc/locuri-de-munca/:keyword',
    en: '/mc/jobs/:keyword',
  },
  '/mc/job/:slug': {
    ro: '/mc/loc-de-munca/:slug',
    en: '/mc/job/:slug',
  },
};
